import {Component, Input, OnInit} from '@angular/core';
import {UserService} from '../../../../services/user-services/user.service';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../../icons-svgs/icons-svgs.component';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'app-accom-roomspec',
    templateUrl: './accom-roomspec.component.html',
    styleUrls: ['./accom-roomspec.component.scss'],
    standalone: true,
    imports: [NgClass, NgIf, IconComponent, TranslateModule]
})
export class AccomRoomspecComponent implements OnInit {

  @Input() tenant;
  @Input() room;
  @Input() hideIfMobile: boolean = false;
  @Input() numberDisplay;
  @Input() isModal;
  @Input() isCarac;

  public isMobile: boolean = false;

  constructor(
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.isMobile = this.userService.isMobileUser;
  }

  getGender(gender){
    if(gender == 'masculin' || gender == 'feminin' ){
      return '/assets/img/gender/'+ gender + '.png';
    }
    return '/assets/img/gender/inconnu.png';
  }

  getGenderKey(gender){
    switch(gender){
      case 'masculin': {
        return 'COMMON.USER.GENDER_MALE';
        break;
      }
      case 'feminin': {
        return 'COMMON.USER.GENDER_FEMALE';
        break;
      }
      default: {
        return 'COMMON.USER.GENDER_UNKNOWN';
        break;
     }
    }
  }

}
